import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { isUndefined } from 'util';
import {
  BehaviorSubject,
  from,
  interval,
  Observable,
  ReplaySubject,
  Subject,
  Subscription,
  takeUntil,
  throttleTime
} from 'rxjs';
import { NotifierWrapService } from '../../../services/notifier-wrap.service';
import { debounceTime, filter, first, map, take } from 'rxjs/operators';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { IMessage } from '../../../services/websocket';
import Lottie from 'lottie-web';
import { DatePipe } from '@angular/common';
import { animate, keyframes, style, transition, trigger } from '@angular/animations';
import { AllService } from '../../../services/all.service';
import { TelegramService } from '../../../pages/page-telegram/telegram.service';
import { VkService } from '../../../pages/page-vk/vk.service';
import { IMessengerConnector, Message, ResultHistory } from '../../../types/all.type';
import { ContextMenuComponent, ContextMenuService } from 'ngx-contextmenu';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ModalService } from '../../../services/modal.service';
import { SnotifyPosition, SnotifyService } from 'ng-snotify';
import { isMobile, log } from '../../../functions';
import { AllMessengersService } from '../../../pages/page-start/all-messengers.service';
import { SettingsService } from '../../../services/settings.service';
import { InterfaceService } from '../../../services/interface.service';
import { CallService } from '../../../services/call.service';
import { SenderService } from '../../../services/sender.service';
import { AppService } from '../../../services/app.service';
import { DcService } from '../../../services/dc.service';
import {FellowdeskService} from "../../../pages/page-fellowdesk/fellowdesk.service";

export function getAttachmentsUrl(message: Message, type: string) {
  const arUri = [];

  if (type === 'voice') {
    arUri.push(message.voice);
  } else if (message?.attachments) {
    message.attachments.forEach((attachment) => {
      if (attachment.type === type) {
        arUri.push(attachment);
      }
    });
  }
  return arUri;
}

@Component({
  selector: 'app-messages-scroll',
  templateUrl: './messages-scroll.component.html',
  styleUrls: ['./messages-scroll.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [
        style({transform: 'translate3d(0,0,0)', offset: 0}),
        animate(
          '1s ease-out',
          keyframes([
            style({transform: 'translate3d(0,-30px,0)', offset: 0.5}),
            style({transform: 'translate3d(0,0,0)', offset: 1})
          ])
        )
      ]),
      transition(':leave', [
        style({transform: 'translate3d(0,0,0)', offset: 0}),
        animate(
          '1s ease-in',
          keyframes([
            style({transform: 'translate3d(0,30px,0)', offset: 0.5}),
            style({transform: 'translate3d(0,0,0)', offset: 1})
          ])
        )
      ])
    ])
  ]
})

export class MessagesScrollComponent implements OnInit, OnDestroy {

  public isLoaded$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public loadCount = 20;
  public loadTopCount = 30;
  public lastVizibleIndex = 10;
  public isLoadHistoryTop$: BehaviorSubject<boolean | 'timeout'> = new BehaviorSubject('timeout');
  public loadHistoryCompleted$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public historyHidden$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public initChat$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  showReadBtn$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  @Input() demoMessage: Message | false = false;
  @Input() Service: IMessengerConnector;
  @Input() inlineMode: boolean;
  //  I initialize the app component.
  private loadHistoryStock$: Observable<any>;
  private loadHistoryStockSubscription: Subscription = new Subscription();
  private loadHistorySubscription: Subscription = new Subscription();
  private loadHistoryTopSubscription: Subscription = new Subscription();
  private isLocalHistoryRestore = false;
  private loadHistoryTopTimeout: NodeJS.Timeout;
  @ViewChild('scrollWrap') scrollWrap: ElementRef;
  public arHistoryBuffer: any = [];
  isLoadSearch = false;
  _searchShow = false;
  FormSearch: UntypedFormGroup;
  // fakeSrc: any;
  @ViewChild('searchInput') searchInput: ElementRef;
  restoreScrollTop: boolean | number = false;
  @ViewChild('messageText') messageText: ElementRef;
  @ViewChild('viewportRef') public viewportRef!: ElementRef;
  unreadCount$: BehaviorSubject<number> = new BehaviorSubject(0);
  @Output() onToggleMessage = new EventEmitter<Message>();
  @Output() onEditMessage = new EventEmitter<Message>();
  @Output() onReplyMessage = new EventEmitter<Message>();
  @Output() onChangeLoaded = new EventEmitter<boolean>();
  private historyCursor: any = {};
  public arHistoryStock: { result: { results: any[] }; offset_id: any; chat_id: any } = {
    offset_id: undefined,
    result: {results: []},
    chat_id: undefined
  };
  loadTopInitiator: 'scroll' | 'end' = 'end';
  detectChanges$: ReplaySubject<string> = new ReplaySubject();
  detectChangesMessage$: ReplaySubject<string> = new ReplaySubject();
  @ViewChild('messagesContainer') messagesContainer: ElementRef;
  @ViewChild(ContextMenuComponent) public contextMenu: ContextMenuComponent;
  @ViewChild('deleteModalContent', {read: TemplateRef})
  private destroy$: Subject<void> = new Subject();

  @HostListener('window:blur', ['$event'])
  onBlur(event: any): void {
    Lottie.stop();
  }

  @HostListener('window:focus', ['$event'])
  onFocus(event: any): void {
    this.readHistory(1000);
  }

  constructor(
    private dcService: DcService,
    public senderService: SenderService,
    public callService: CallService,
    private renderer: Renderer2,
    public settingsService: SettingsService,
    public allMessengersService: AllMessengersService,
    private snotifyService: SnotifyService,
    public contextMenuService: ContextMenuService,
    public modalService: ModalService,
    private modal: NzModalService,
    private datepipe: DatePipe,
    public notifierWrapService: NotifierWrapService,
    public allService: AllService,
    public cd: ChangeDetectorRef,
    public appService: AppService,
    public interfaceService: InterfaceService,
    public fellowdeskService: FellowdeskService
  ) {

    if (this.loadTopInitiator !== 'scroll') {
      this.initChat$.next(true);
      // / this._isLoadHistoryTop = false;
    }
    this.detectChanges$.pipe(debounceTime(500)).subscribe((text) => {
      log('MessagesScrollComponent detectChanges$', text);
      this.cd.detectChanges();
    });
    this.detectChangesMessage$.pipe(
      // Ограничиваем количество вызовов debounceTime до одного за 500 мс
      debounceTime(500),
      // Ограничиваем количество вызовов throttleTime до одного за 2000 мс (2 секунд)
      throttleTime(2000)
    ).subscribe((text) => {
      log('MessagesScrollComponent detectChangesMessage$', text);
      this.cd.detectChanges();
    });
  }

  reload() {
    log('Reload history');
    if (this.Service.openChatId) {
      this.initChat$.next(false);
      //  window.requestAnimationFrame( () => this.loadHistory(this.Service.openChatId));
      this.loadHistory(true);
    }
  }

  public ngOnInit(): void {
    this.isLoaded$.subscribe((v) => {
      this.onChangeLoaded.next(v);
    });

    this.isLoadHistoryTop$.subscribe(() => {
      this.detectChanges$.next('isLoadHistoryTop$');
    });
    this.interfaceService.resizeObservable$.pipe(takeUntil(this.destroy$), throttleTime(100)).subscribe(() => {
      if (this.Service.loadHistoryError) {
        return;
      }
      if (this.getContainerScrollBottom() < 350) {
        this.scrollToEnd();
      }
    });
    this.isLoaded$.next(this.Service.arHistory?.length > 0);
    this.scrollToEnd();
    this.initFormsSearch();
    const setContainerSize = () => {
      setTimeout(() => {
        try {
          const size = this.getContainerSize;
          this.renderer.setAttribute(this.messagesContainer.nativeElement, 'data-size', size);
        }catch (e) {
          console.error(e);
        }
      }, 50);
    };
    this.interfaceService.resizeObservable$.pipe(throttleTime(100), takeUntil(this.destroy$)).subscribe(() => {
      setContainerSize();
    });
    this.interfaceService.showDetail$.pipe(throttleTime(100), takeUntil(this.destroy$)).subscribe((id) => {
      setContainerSize();
    });
    this.dcService.detectChanges$
      .pipe(filter(v => v === 'messages-scroll'), throttleTime(100), takeUntil(this.destroy$))
      .subscribe((component) => {
        this.detectChanges$.next('dcService.detectChanges$');
      });
    this.allMessengersService.setService$.pipe(throttleTime(100), takeUntil(this.destroy$)).subscribe((event) => {
      //  TODO если отрывают прошлый то не чистить
      //   log(this.allService._openChatId, this.allMessengersService.Service._openChatId, this.allService.lastChatId);
      this.allMessengersService.Service.arHistory = [];
      this.Service = this.allMessengersService.Service;
      this.detectChanges$.next('setService$');
    });
    this.allService.reloadChat$.pipe(takeUntil(this.destroy$), debounceTime(600)).subscribe((event) => {
      this.reload();
    });
    this.interfaceService.scrollToMessage$.pipe(throttleTime(100), takeUntil(this.destroy$)).subscribe((message) => {
      if (message) {
        this.dcService.detectChanges$.next('message-animate-' + message.id);
        const scrollTarget = document.querySelector('#message-' + message.id);
        log('scrollTarget', scrollTarget, message);
        if (scrollTarget) {
          const scrollingElement = this.viewportRef.nativeElement;
          const topOffset = scrollingElement.offsetHeight;
          const elementPosition = scrollTarget.getBoundingClientRect().bottom;
          const offsetPosition = elementPosition - topOffset + 100;
          scrollingElement.scrollBy({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }
    });
    this.allService.wsService.status
      .pipe(throttleTime(100), takeUntil(this.destroy$))
      .subscribe((status) => {
        if (status && this.allService.wsService.disconnect) {
          setTimeout(() => {
            log('loadHistory wsService disconnect');
            this.loadHistory();
          }, 5000);
        }
      });
    if (this.inlineMode) {
      this.init();
    } else {
      this.interfaceService.openChat$.pipe(throttleTime(100), takeUntil(this.destroy$)).subscribe((event) => {
        if (!event) {
          console.log('allService.openChat$ skip !event');
          return;
        }
        this.init();
      });
    }

    // return;
    this.interfaceService.scrollChat$
      .pipe(throttleTime(100), takeUntil(this.destroy$))
      .subscribe((val) => {
        this.cd.detectChanges();
        this.scrollToEnd();
      });
    this.interfaceService.searchToggle$
      .pipe(throttleTime(100), takeUntil(this.destroy$), filter(v => v))
      .subscribe((val: boolean) => {
        this.searchShow = !this.searchShow;
      });
    this.allService.wsService
      .on<IMessage>('edit_message')
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (this.checkMessageInChat(this.Service.openChatId, data.edit_message)) {
          from(this.Service.arHistory)
            .pipe(filter((v: any) => v.id === data.edit_message.id))
            .subscribe((message: Message) => {
              log('edit_message');
              message.read = data.edit_message.read;
              message.text = data.edit_message.text;
              message.edit_date = data.edit_message.edit_date;
              this.dcService.detectChanges$.next('message');
            });
          this.saveOpenHistory();
        }
        this.detectChanges$.next('edit_message');
      });

    this.allService.wsService
      .on<IMessage>('online')
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (this.Service.openChatId === data.user_id && this.Service.type === data.path) {
          from(this.Service.arHistory)
            .pipe(filter((v: any) => v.from_user.id === data.user_id))
            .subscribe((message: Message) => {
              message.online = data?.online;
              this.dcService.detectChanges$.next('message-' + message.id);
            });
          this.Service._openChat.online = data?.online;
          this.Service._openChat.last_seen = data?.last_seen;
          this.detectChanges$.next('online');
        }
      });
    this.allService.wsService
      .on<IMessage>('read')
      .pipe(takeUntil(this.destroy$))
      // TODO проверить активный ли чат смотрит
      .subscribe((data) => {
        from(this.Service.arHistory)
          .pipe(filter((v: any) => v.id <= data.max_id && data.read !== 'inbox' && !v.read))
          .subscribe((message: Message) => {
            message.read = true;
            this.dcService.detectChanges$.next('message-' + message.id);
            this.detectChanges$.next('read');
          });
        this.saveOpenHistory();
      });
    this.allService.wsService
      .on<IMessage>('delete_messages')
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.deleteMessages(data.delete_messages);
      });

    this.allService.wsService
      .on<IMessage>('new_message')
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (
          this.checkMessageInChat(this.Service.openChatId, data.new_message)
        ) {
          setTimeout(() => {
            this.addMessage(data.new_message);
          }, 300);
        }
      });
    this.allService.newMessage$.pipe(takeUntil(this.destroy$)).subscribe((resultMessage) => {
      this.addMessage(resultMessage);
    });

    this.interfaceService.readHistory$.pipe(takeUntil(this.destroy$), debounceTime(5000)).subscribe((id) => {
      this.detectChanges$.next('readHistory');
      const maxId = this.Service.arHistory.slice(-1)[0]?.id;
      log('readHistory maxId', maxId);
      if (maxId) {
        this.Service.readHistory(this.Service.openChatId, maxId).subscribe(
          () => {
            log('readHistory success');
            //  this.cd.detectChanges();
          },
          (error) => {
            //  this.interfaceService.errorHandling(error, true, this.Service);
          }
        );
      }
    });
  }

  checkMessageInChat(chatId: string | number, message: Message) {
    return this.Service.openChatId === message.chat_id
      || // TODO
      (typeof this.Service.openChatId === 'string' && this.Service.openChatId === message?.from_user?.username)
  }

  init(): void {
    if (this.Service.type === 'sender') {
      setTimeout(() => {
        this.interfaceService.editor.commands.focus();
      }, 500);
    }
    log('openChat$ allService.openChat$ subscribe');

    log('/-------loadHistory openChat$ Start -------/');
    this.initChat$.next(false);
    setTimeout(() => {
      this.Service.loadHistoryError = false;
      this.loadHistoryCompleted$.next(false);
      clearTimeout(this.loadHistoryTopTimeout);
      if (this.loadHistorySubscription) {
        this.loadHistorySubscription.unsubscribe();
      }
      if (this.loadHistoryTopSubscription) {
        this.loadHistoryTopSubscription.unsubscribe();
      }
      if (this.loadHistoryStockSubscription) {
        this.loadHistoryStockSubscription.unsubscribe();
      }
      this.unreadCount$.next(0);
      this.historyCursor = {};
      this._searchShow = false;
      this.isLoadHistoryTop$.next(false);
      this.scrollToEnd('openChat$');
      this.loadHistory(false, 'openChat$');
      // if (!this.localHistoryRestore()){
      //  alert('lh');
      // }
      this.cd.detectChanges();
    }, 25);
  }

  readMessage(visible, timeout, message: Message | false = false) {
    if (!visible || (message && message.read) || !this.allService.isFocused()) {
      return;
    }
    this.readHistory(timeout);
  }

  readHistory(timeout = 3000, force = false): void {
    if (this.Service.type === 'sender') {
      return;
    }
    log('readHistory start', this.allService.isFocused(), this.Service.arHistory?.length);
    if (
      (this.Service.arHistory.filter((v) => !v.read)?.length === 0 ||
        !this.allService.isFocused() ||
        this.settingsService.arConfig?.read_btn?.value) &&
      !force
    ) {
      //  TODO читать в chat-list когда скипает
      log('readHistory skip');
      return;
    }

    this.showReadBtn$.next(false);
    this.unreadCount$.next(0);
    from(this.Service.arHistory)
      .pipe(filter((message) => !message.read && !message.out))
      .subscribe((message) => {
        //  log('Read', message.text_list)
        message.read = true;
        this.dcService.detectChanges$.next('message-' + message.id);
      });
    this.interfaceService.readHistory$.next();
    log('readHistory end');
  }

  private localHistoryRestore(text = ''): boolean {

    if (this.Service?.noHistoryCache) {
      return false;
    }
    const id = this.Service.openChatId;
    if (this.localHistoryExist() && id) {
      //  alert('localHistoryRestore: ' + id);
      setTimeout(() => {
        this.isLoaded$.next(true);
        this.initChat$.next(true);
        this.Service.arLocalHistory[id] = this.addInitFields(this.Service.arLocalHistory[id]);
        this.Service.arHistory = this.Service.arLocalHistory[id];
        this.historyHidden$.next(false);
        this.isLoadHistoryTop$.next(false);
        this.cd.detectChanges();
        this.scrollToEnd('localHistoryRestore');

        log('localHistoryRestore', text, id);
      }, 10);
      return true;
    }
    return false;
  }

  private localHistoryExist(): boolean {
    const id = this.Service.openChatId;
    return typeof this.Service.arLocalHistory[id] !== 'undefined';
  }

  //  I get the current scroll height of the container.
  private getContainerScrollHeight(): number {
    return this.viewportRef?.nativeElement?.scrollHeight;
  }

  //  I get the current scroll offset of the container.
  private getContainerScrollTop(): number {
    return this.viewportRef?.nativeElement?.scrollTop;
  }

  private getContainerScrollBottom(): number {
    const scrollHeight = this.getContainerScrollHeight();
    const scrollTop = this.getContainerScrollTop();
    const offsetHeight = this.viewportRef?.nativeElement?.offsetHeight;
    //  log('preScrollInfo: ', preScrollHeight, height, preScrollTop);
    return scrollHeight - (scrollTop + offsetHeight);
  }

  //  I update the container to use the new scroll offset.
  private setScrollTop(currentScrollTop: boolean | number, delta: number): void {
    if (typeof currentScrollTop === 'number') {
      this.viewportRef.nativeElement.scrollTop = currentScrollTop + delta;
    }
  }

  /*scrollToTop (duration) {
      const cosParameter = this.viewportRef.nativeElement.scrollTop / 2;
      let scrollCount = 0, oldTimestamp = null;

      const step = (newTimestamp) => {
        if (oldTimestamp !== null) {
          //  if duration is 0 scrollCount will be Infinity
          scrollCount += Math.PI * (newTimestamp - oldTimestamp) / duration;
          if (scrollCount >= Math.PI) return 0;
          this.viewportRef.nativeElement.scrollTop = cosParameter + cosParameter * Math.cos(scrollCount);
        }
        oldTimestamp = newTimestamp;
        window.requestAnimationFrame(step);
      }
      window.requestAnimationFrame(step);
    }*/
  addMessage(message: Message) {
    if (!message.out) {
      this.showReadBtn$.next(this.settingsService.arConfig?.read_btn?.value);
    }
    message.show = true;
    message.animate_add = true;
    console.log('addMessage', message);
    if (!this.Service.arHistory.find((v) => v.id === message.id)) {
      const getContainerScrollBottom = this.getContainerScrollBottom();
      const prevMessage = this.Service.arHistory[this.Service.arHistory?.length - 1];
      message.prev_user = message?.from_id === prevMessage?.from_id && !prevMessage?.voice && !prevMessage?.sticker;
      if (this.Service.arHistory?.length > 100) {
        this.Service.arHistory.shift();
        log('Clear old history', this.Service.arHistory?.length);
      }
      this.Service.arHistory.push(message);
      this.cd.detectChanges();
      //  Читаем
      setTimeout(() => {
        if (getContainerScrollBottom < 250) {
          if (!message.out) {
            this.readHistory();
          }
          this.scrollToEnd();
        } else {
          if (!message.out) {
            message.read = false;
            this.unreadCount$.next(this.unreadCount$.value + 1);
            // this.detectChangesMessage$.next('addMessage 2');
            this.cd.detectChanges();
          }
        }
        this.saveOpenHistory();
      }, 100);
    }
    return true;
  }

  deleteMessages(iDs: string[] | number[]) {
    let deleted = false;
    iDs.forEach((id) => {
      from(this.Service.arHistory)
        .pipe(filter((v: any) => v.id === id))
        .subscribe((message: Message) => {
          message.delete = true;
          this.dcService.detectChanges$.next('message-' + message.id);
          deleted = true;
        });
    });
    if (deleted) {
      this.saveOpenHistory();
      this.detectChanges$.next('deleteMessages');
    }
  }

  saveOpenHistory(): void {
    this.Service.arHistory.map((v) => (v.animate_add = false));
    this.Service.setLocalHistory(this.Service.openChatId, this.Service.arHistory.slice(-15));
  }

  loadHistory(force = false, text = ''): void {
    if (!force && this.allService.lastChatId === this.Service.openChatId && this.Service.arHistory?.length > 0) {
      log('loadHistory skip', this.allService.lastChatId, this.Service.openChatId, this.Service.arHistory?.length);
      //  this.scrollToEnd();
      return;
    }
    this.allService.arPinnedMessages = [];
    this.allService.lastChatId = this.Service.openChatId;
    if (this.Service.arHistory?.length === 0) {
      this.historyHidden$.next(true);
    }
    const id = this.Service.openChatId;
    this.loadHistoryCompleted$.next(false);
    this.loadHistorySubscription.unsubscribe();
    this.loadHistoryTopSubscription.unsubscribe();
    this.Service.loadHistoryError = false;
    this.isLocalHistoryRestore = false;
    if (true || this.Service.openChat?.expired_history) { //   || !this.localHistoryExist()
      this.isLoaded$.next(false);
    } else {
      this.isLocalHistoryRestore = !force && this.localHistoryRestore(`${text}->loadHistory`);
      this.isLoadHistoryTop$.next(true);
    }
    this.dcService.detectChanges$.next('chat-show');
    //  TODO
    log(text, 'getHistory all', this.Service.type, this.allMessengersService.Service.type);
    this.cd.detectChanges();
    const fromMessage = this.demoMessage ? this.demoMessage.id : false;
    const fromChat = this.demoMessage ? this.demoMessage.chat_id : false;
    this.loadHistorySubscription = this.Service.getHistory(
      id, 0, 0, this.loadCount, {}, fromMessage, fromChat
    ).subscribe(
      (result: ResultHistory) => {
        this.loadHistoryCompleted$.next(result?.results?.length < this.loadCount);
        this.showReadBtn$.next(!!(
          this.settingsService.arConfig?.read_btn?.value && this.Service.openChat?.unread_messages_count > 0
        ));

        this.historyCursor = result?.cursor;
        setTimeout(() => {
          if (!isUndefined(result.chat)) {
            //  result.chat.online = true;
            this.Service.openChat = Object.assign(result.chat, this.Service.openChat);
          }
          //  Закреп
          if (result?.pinned_message && !result.pinned_message.empty) {
            //  this.onPinned.next(result.pinned_message)
            this.allService.arPinnedMessages = [result.pinned_message];
          }
          result.results.forEach((v) => (v.show = true));
          result.results = this.addInitFields(result.results);

          this.showReadBtn$.next(!!(
            this.settingsService.arConfig?.read_btn?.value && this.Service.openChat?.unread_messages_count > 0
          ));
          this.Service.arHistory = result.results;
          //  Restore last message
          if (this.Service.arHistory?.length === 0 && this.Service.openChat?.last_message?.text) {
            this.Service.openChat.last_message.show = true;
            this.Service.arHistory.push(this.Service.openChat.last_message);
            log('Restore last message to arHistory', this.Service.arHistory);
          }
          if (this.Service.arHistory.length > 0 && this.inlineMode) {
            this.Service.forwardMessage = false;
          }
          this.isLoaded$.next(true);
          log('openChat$', 'Load ok and set arHistory', this.Service.type);
          this.historyHidden$.next(false);
          this.isLoadHistoryTop$.next(false);
          this.cd.detectChanges();
          this.scrollToEnd(`${text}->loadHistory`);
          setTimeout(() => {
            this.scrollToEnd(`${text}->loadHistory timeout`);
          }, 50);
          setTimeout(() => {
            this.Service.openChat.expired_history = false;
            this.Service.setLocalHistory(id, this.Service.arHistory);
            this.initChat$.next(true);
            log('/======loadHistory openChat$ End ======/');
            setTimeout(() => {
              this.loadHistoryStock(`${text}->loadHistory`);
            }, 2000);
          }, 30);
          //  this.Service.messageText?.nativeElement.focus();
          this.dcService.detectChanges$.next('chat-show');
          // Показываю поле чата если есть переписка
          this.interfaceService.isShowTextarea$.next(this.inlineMode);

        }, 0);
      },
      (error) => {
        this.isLoaded$.next(true);
        this.isLoadHistoryTop$.next(false);
        this.historyHidden$.next(false);
        this.Service.loadHistoryError = error;
        this.dcService.detectChanges$.next('chat-show');
        if (this.Service.openChat?.expired_history || this.interfaceService.isTelesellerDomain) {
          //  alert('localHistoryRestore!!');
          this.localHistoryRestore();
        }
        if (!force && !this.isNoPermissionPersonalError()) {
          setTimeout(() => {
            this.loadHistory(true);
          }, 5000);
        }
        this.detectChanges$.next('loadHistory Error');
      }
    );
  }

  private addInitFields(arHistory: Message[]): Message[] {
    for (let i = 0; i < arHistory?.length; i++) {
      const message = arHistory[i];
      this.callService.replaceCallMessage(message, this.Service);
      const prevMessage = arHistory[i - 1];
      if (!prevMessage) {
        continue;
      }
      message.prev_user = message?.from_id === prevMessage?.from_id && !prevMessage?.voice && !prevMessage?.sticker;
      message.space = message.prev_user && message?.date - prevMessage?.date < 120;
      message.date_format = this.datepipe.transform(message.date, 'd MMMM YYYY');
      message.show_title = i === 0 || arHistory[i - 1]?.date_format !== arHistory[i]?.date_format;
    }
    return arHistory;
  }

  private fixScrollTop(): void {
    const preScrollHeight = this.getContainerScrollHeight();
    const preScrollOffset = this.getContainerScrollTop();
    if (preScrollOffset < 1) {
      setTimeout(() => {
        const postScrollHeight = this.getContainerScrollHeight();
        const newOffset = preScrollOffset + (postScrollHeight - preScrollHeight);
        this.setScrollTop(newOffset, 0);
        console.warn('Scrolling by', newOffset, 'px');
        this.cd.detectChanges();
      }, 0);
    }
  }

  private addMessagesHistory(messages: Message[]): void {
    const preLen = this.Service.arHistory?.length;
    this.Service.arHistory = [...messages, ...this.Service.arHistory];
    const postLen = this.Service.arHistory?.length;
    interval(10)
      .pipe(
        take(postLen - preLen),
        map((i) => this.Service.arHistory[postLen - preLen - (i - 1)])
      )
      .subscribe({
        next: (v: any) => {
          this.fixScrollTop();
          if (v) {
            v.show = true;
            this.cd.detectChanges();
          }
        },
        complete: () => {
          const minTopLoad = this.Service.arHistory?.length > 15 ? 2200 : 800;
          this.isLoadHistoryTop$.next(false);
          if (this.getContainerScrollTop() < minTopLoad) {
            this.loadHistoryTop(true);
          }
        }
      });

    return;
  }

  loadHistoryStock(text = '') {
    if (this.loadHistoryStockSubscription) {
      this.loadHistoryStockSubscription.unsubscribe();
    }
    this.arHistoryStock.result.results = [];
    const offsetId = this.Service.arHistory ? this.Service.arHistory[0]?.id : 0;
    log('loadHistoryStock', text, offsetId, this.Service.arHistory?.length);
    this.loadHistoryStock$ = this.Service.getHistory(
      this.Service.openChatId,
      offsetId,
      this.arHistoryStock.result.results?.length + this.Service.arHistory?.length,
      this.loadTopCount,
      this.historyCursor
    );
    this.loadHistoryStockSubscription = this.loadHistoryStock$.subscribe(
      (result: any) => {
        this.loadHistoryStockSubscription.unsubscribe();
        delete this.loadHistoryStock$;
        this.historyCursor = result?.cursor;
        this.arHistoryStock = {
          offset_id: offsetId,
          result,
          chat_id: this.Service._openChatId
        };
        log(text, 'loadHistoryStock end', offsetId);
      },
      (error) => {
        if (error.status === 404) {
          this.loadHistoryCompleted$.next(true);
        }
        log(text, 'loadHistoryStock Error', error);
      }
    );
  }

  getHistory(
    chatId: string | number,
    offsetId: string | number = 0,
    currentCount: number,
    limit = 15,
    cursor: any = {}
  ): Observable<any> {
    if (
      this.arHistoryStock.offset_id === offsetId &&
      this.arHistoryStock.chat_id === chatId &&
      this.arHistoryStock.result.results?.length > 0
    ) {
      //  alert(offset_id)
      return new Observable((observer) => {
        setTimeout(() => {
          observer.next(this.arHistoryStock.result);
          observer.complete();
          log('getHistoryLocal: ' + offsetId);
        }, 10);
      }).pipe(first()); //  , tag("getHistory")
    } else if (this.loadHistoryStock$) {
      console.warn('loadHistoryStock$ OK');
      return this.loadHistoryStock$;
    } else {
      log('!getHistory', chatId, offsetId, currentCount);
      return this.Service.getHistory(chatId, offsetId, currentCount, limit, cursor);
    }
  }

  loadHistoryTop(visible = true) {
    const time = new Date().getTime();
    if (
      !this.initChat$.value ||
      !this.isLoaded$.value ||
      this.isLoadHistoryTop$.value ||
      this.isLoadHistoryTop$.value === 'timeout' ||
      this.loadHistoryCompleted$.value ||
      this.Service.arHistory?.length === 0 ||
      !visible
    ) {
      log(
        !this.initChat$.value,
        !this.isLoaded$.value,
        this.isLoadHistoryTop$.value,
        this.loadHistoryCompleted$.value,
        this.Service.arHistory?.length
      );
      return;
    }
    log('/---loadHistoryTop Start--/');
    //  this.cd.detach();
    this.isLoadHistoryTop$.next(true);
    this.loadHistoryTopSubscription.unsubscribe();
    const offsetId = this.Service.arHistory ? this.Service.arHistory[0]?.id : 0;
    clearTimeout(this.loadHistoryTopTimeout);
    this.loadHistoryTopTimeout = setTimeout(() => {
      // if(this.loadHistoryTopSubscription)
      //  this.loadHistoryTopSubscription.unsubscribe();
      this.isLoadHistoryTop$.next(false);
      console.error('loadHistoryTopSubscription');
    }, 20000);
    this.loadHistoryTopSubscription = this.getHistory(
      this.Service.openChatId,
      offsetId,
      this.Service.arHistory?.length,
      this.loadTopCount,
      this.historyCursor
    ).subscribe(
      (result) => {
        clearTimeout(this.loadHistoryTopTimeout);
        this.Service.loadHistoryError = false;
        this.historyCursor = result?.cursor;
        if (this.Service.type !== 'sender') {
          this.loadHistoryCompleted$.next(result?.results?.length < this.loadTopCount);
        }
        log('!!: ', result.results?.length, this.loadTopCount, this.loadHistorySubscription.closed);
        //  alert(this.loadHistoryCompleted + ' ' + result.results?.length + ' ' + this.loadTopCount);
        result.results = this.addInitFields(result.results);
        if (this.loadTopInitiator === 'scroll') {
          this.isLoadHistoryTop$.next('timeout');
          this.addMessagesHistory(result.results);
          this.loadHistoryStock();
        } else {
          const timeOut = new Date().getTime() - time > 100 ? 0 : 100;
          const newHistory = [...result.results, ...(this.Service.arHistory || [])];
          setTimeout(() => {
            log('timeOut: ' + timeOut);
            if (this.allService.isAndroid()) {
              this.scrollToTop(5);
            } else {
              this.scrollToTop();
            }
            result.results.forEach((message) => {
              message.show = true;
            });
            this.Service.arHistory = newHistory;
            log('openChat$ loadHistoryTop set arHistory');
            //  this.cd.detectChanges();
            //  const message = this.Service.arHistory[this.Service.arHistory?.length - this.loadTopCount];
            this.isLoadHistoryTop$.next(false);
            this.cd.detectChanges();
            this.loadHistoryStock();
            log('/===loadHistoryTop End===/');
          }, timeOut);
        }
      },
      (error) => {
        if (error.status === 404) {
          this.loadHistoryCompleted$.next(true);
        } else {
          this.Service.loadHistoryError = error;
        }
        clearTimeout(this.loadHistoryTopTimeout);
        this.dcService.detectChanges$.next('chat-show');
        this.isLoadHistoryTop$.next(false);
      }
    );
  }

  vizibleDate(vizible: boolean, message: Message, index: number) {
    if (message.load) {
      if ((!vizible && this.Service.messageLastDate < message.date) || !this.Service.messageLastDate) {
        //  this.Service.messageLastDate = message.date;
      } else if (vizible && this.Service.messageLastDate > message.date) {
        //  const index = this.arDates.findIndex((v) => v === message.date);
        //  if(index > -1)
        //   this.Service.messageLastDate = this.arDates[index - 2];
        delete this.Service.messageLastDate;
      }
      //  this.cd.detectChanges();
    } else {
      /*this.arDates.unshift(message.date);
            this.arDates = this.arDates.sort(function(a, b) {
              return a - b;
            });*/
      message.load = true;
    }
  }

  vizibleMesage(vizible: boolean, message: Message, index: number): void {
    // if(vizible){
    const minTopLoad = this.Service.arHistory?.length > this.loadCount ? 30 : 10;
    if (this.loadTopInitiator === 'scroll' && this.lastVizibleIndex > index && index < minTopLoad) {
      this.loadHistoryTop(true);
    }
    this.lastVizibleIndex = index;
    // }
  }

  backToTop() {
    /* if (this.getContainerScrollTop() - 500 > this.lastScrollTop ) {
           this.waiting = true;
           this.viewportRef.nativeElement.scrollBy(0, -50);
           setTimeout(() => this.backToTop(), 50);
         }else{
           this.waiting = false;
         }
         */
  }

  trackByFn(index, element: any) {
    return element ? element.id : undefined;
  }

  scrollToEnd(text = '') {
    if (this.viewportRef?.nativeElement) {
      requestAnimationFrame(() => {
        const scrollingElement = this.viewportRef.nativeElement;
        scrollingElement.scrollTop = scrollingElement.scrollHeight;
        log('scrollToEnd', text);
      });
    }
  }

  scrollToTop(px = 1) {
    const scrollingElement = this.viewportRef.nativeElement;
    scrollingElement.scrollTop = px;
  }

  initFormsSearch() {
    this.FormSearch = new UntypedFormGroup({
      q: new UntypedFormControl('', [Validators.minLength(3), Validators.required])
    });
  }

  onSearch() {
    const controls = this.FormSearch.controls;
    const values = this.FormSearch.value;
    //  Проверяем форму на валидность */
    if (this.FormSearch.invalid) {
      //  Если форма не валидна, помечаем все контролы как touched **/
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }
    this.isLoadSearch = true;
    this.initChat$.next(false);
    this.Service.getChatSearch(this.Service.openChatId, 'empty', values.q, 0, 100).subscribe(
      (result: any) => {
        if (result.result?.length === 0) {
          this.searchInput.nativeElement.focus();
          this.notifierWrapService.notify('info', 'По запросу сообщений не найдено.');
        }
        result.result.forEach((v) => (v.show = true));
        result.result = this.addInitFields(result.result);
        this.Service.arHistory = result.result;
        this.isLoadSearch = false;
        this.cd.detectChanges();
        setTimeout(() => {
          this.initChat$.next(true);
        }, 300);
      },
      (error) => {
        this.interfaceService.errorHandling(error, true, this.Service);
      }
    );
  }

  get searchShow() {
    return this._searchShow;
  }

  set searchShow(val) {
    if (val) {
      this.restoreScrollTop = this.getContainerScrollTop();
      this.arHistoryBuffer = this.Service.arHistory;
      this.Service.arHistory = [];
      setTimeout(() => {
        this.searchInput.nativeElement.focus();
      }, 300);
    } else {
      this.Service.arHistory = this.arHistoryBuffer;
      setTimeout(() => {
        //  this.lastVizibleIndex
        this.setScrollTop(this.restoreScrollTop, 0);
      }, 300);
      this.arHistoryBuffer = [];
    }
    this._searchShow = val;
    this.cd.detectChanges();
  }

  get runChangeDetection() {
    this.allService.arDetectChangesLog.MessagesScrollComponent++;
    return '';
  }

  closeSearch() {
    this.searchShow = false;
  }

  dbClick($event: any, message: Message) {
    log('dbClick', $event);
    if (
      !$event?.path[0].classList.contains('text-break') &&
      this.allService.permissionsCheck('can_send_messages', this.Service) !== false
    ) {
      this.onReplyMessage.next(message);
    }
  }

  //  Context Menu
  deleteMessage(message) {
    log('deleteMessage: ' + message.id);

    this.notifierWrapService.playAudio('open');
    const deleteMessage = (isDeleteAllMessage = false) => {
      this.Service.deleteMessages(this.Service.openChatId, isDeleteAllMessage, [message.id.toString()]).subscribe(
        (result: any) => {
          message.delete = true;
          this.notifierWrapService.playAudio('delete');
          this.allService.wsService.wsMessages$.next({
            event: 'delete_messages',
            type: this.Service.type,
            data: {delete_messages: [message.id]}
          });
          this.detectChanges$.next('deleteMessage');
          this.notifierWrapService.notify('success', 'Сообщение удалено', SnotifyPosition.centerTop);
          log('deleteMessage ok: ' + message.id);
        },
        (error) => {
          this.interfaceService.errorHandling(error, true, this.Service);
        }
      );
    };
    this.snotifyService.clear();
    this.snotifyService.confirm('Вы действительно хотите удалить сообщение?', '', {
      timeout: 30000,
      showProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      type: 'success',
      position: SnotifyPosition.centerTop,
      buttons: [
        {
          text: 'Да',
          action: () => {
            deleteMessage();
          },
          bold: false
        },
        {
          text: 'Для всех',
          action: () => {
            deleteMessage(true);
          },
          bold: false
        },
        {text: 'Отменить', action: () => log('Clicked: No')}
      ]
    });
  }

  toggleMessage(message: Message, force = false) {
    message.force_select = force;
    this.onToggleMessage.emit(message);
    this.cd.detectChanges();
    this.dcService.detectChanges$.next('message-' + message.id);
    //  force && $event.preventDefault();
  }

  public isToggle(message: Message): boolean {
    return message?.select && !message.deleted;
  }

  public isUnToggle(message: Message): boolean {
    return !message?.select && !message.deleted;
  }

  public isDelete(message: Message): boolean {
    return !message.deleted;
  }

  public isEdit(message: Message): boolean {
    return !!(message?.out && message?.text && !message.deleted);
  }

  public isVoice(message: Message): any {
    return message?.voice;
  }

  public isAudio(message: Message): boolean {
    return getAttachmentsUrl(message, 'audio').length > 0;
  }

  public isDocument(message: Message): boolean {
    return getAttachmentsUrl(message, 'document').length > 0;
  }

  public isVideoNote(message: Message): boolean {
    return getAttachmentsUrl(message, 'video_note').length > 0;
  }

  public isVideo(message: Message): boolean {
    return getAttachmentsUrl(message, 'video').length > 0;
  }

  public isPhoto(message: Message): boolean {
    return getAttachmentsUrl(message, 'photo').length > 0;
  }

  public isText(message: Message): boolean {
    return !!(message?.text || message?.reply_to_messages);
  }

  public isTextSelected(message: Message): boolean {
    if (window?.getSelection() && !message.deleted) {
      const select = window.getSelection().toString();
      return select?.length > 0;
    }
    return false;
  }

  isTextModal(message: Message) {
    return (message?.text?.length > 25 || message?.reply_to_messages) && isMobile();
  }

  public copyText(message: Message): void {
    const text = this.allService.renderTextMessage(message);
    this.allService.copyTextToClipboard(text);
  }

  public copySelectedText(): void {
    document.execCommand('copy');
  }

  public editMessageText(message: Message) {
    this.onEditMessage.emit(message);
    this.interfaceService.editor.commands.focus();
    //  this.dcService.detectChanges$.next('chat-show');
  }

  replyMessageText(message: Message) {
    this.dcService.detectChanges$.next('chat-show');
    this.onReplyMessage.emit(message);
  }

  public getAttachmentsUrl(message: Message, type: string) {
    const arUri = [];

    if (type === 'voice') {
      arUri.push(message.voice);
    } else if (message?.attachments) {
      message.attachments.forEach((attachment) => {
        if (attachment.type === type) {
          arUri.push(attachment);
        }
      });
    }
    return arUri;
  }

  public downloadAttachments(message: Message, type: string): void {
    getAttachmentsUrl(message, type).forEach((attachment) => {
      if (!attachment.file_uri) {
        this.Service.getFileSrc(attachment);
      }

      if (!attachment.file_uri) {
        //  TODO
        this.notifierWrapService.notify('error', 'Файл не найден');
        return;
      }
      let downloadUrl = attachment.file_uri;
      if (this.Service instanceof TelegramService) {
        if (downloadUrl?.length > 0 && downloadUrl.indexOf('?') > -1) {
          downloadUrl += '&download=true';
        }
      }
      if (this.Service instanceof VkService) {
        downloadUrl =
          'https:// messenger.soft-angel.ru/vk.download.php?download_url=' + encodeURIComponent(attachment.file_uri);
        if (attachment.file_name) {
          downloadUrl += '&file_name=' + attachment.file_name;
        } else {
          downloadUrl += '&file_name=' + this.allService.basename(attachment?.file_uri || '', '');
        }
        /*download(url, {
                  method: 'GET',
                  getProgress(percentage) {
                    log(`Download progress：${percentage}`)
                  }
                })
                  .catch(error => { log(error) })
                  .finally(() => log('A successful or failed operation, such as the handling of loading'))
                */
      }
      this.allService.downloadFile(downloadUrl).subscribe();
    });
  }

  copyTextModal(message: Message): void {
    this.modalService.openModal('ModalCopyTextComponent', {
      text: this.allService.renderTextMessage(message, '<br>')
    });
  }

  selectMessages() {
    try {
      const range = window?.getSelection()?.getRangeAt(0);
      const selectionContents = range.cloneContents();
      if (selectionContents.childNodes?.length > 1) {
        selectionContents.childNodes.forEach((el: Element, i) => {
          try {
            const id = parseInt(el.getAttribute('data-id'), 10);
            if (id) {
              setTimeout(() => {
                const message = this.Service.arHistory.find((v) => v.id === id);
                if (!message.delete) {
                  message.force_select = true;
                  message.select = false;
                  this.onToggleMessage.emit(message);
                  this.dcService.detectChanges$.next('message-' + message.id);
                  this.detectChanges$.next('selectMessages');
                }
              }, 5 * i);
            }
          } catch (e) {
          }
        });
        this.allService.selectTextCancel();
      }
    } catch (e) {
      log(e);
    }
  }

  get getContainerSize(): string {
    const size = this.messagesContainer?.nativeElement?.offsetWidth || 1200;

    if (size >= 700) {
      return 'xl';
    } else if (size > 600) {
      return 'lg';
    } else if (size > 500) {
      return 'sm';
    }
    return 'xs';
  }

  public contextMenuOpen(data: any): void {
    if (this.interfaceService.openDropdown$.value) {
      return;
    }
    //  this.notifierWrapService.onOpenPlay();
    this.contextMenuService.show.next({
      anchorElement: data.event.target,
      //  Optional - if unspecified, all context menu components will open
      contextMenu: this.contextMenu,
      event: data.event,
      item: data.message
    });
    data.event.preventDefault();
    data.event.stopPropagation();
  }

  ngOnDestroy() {
    try {
      this.destroy$.next();
      this.destroy$.complete();
    } catch (e) {

    }
    this.loadHistoryTopSubscription.unsubscribe();
    this.loadHistorySubscription.unsubscribe();
  }

  addAccount() {
    this.modalService.openModal('ModalAddAccountComponent', {Service: this.Service});
    this.interfaceService.showMobileHome = false;
  }


  isNoPermissionPersonalError(): boolean {
    return this.Service.loadHistoryError?.error?.detail?.error_code === 'NOT_PERMISSION_PRIVATE_CHAT';
  }
  readonly isMobile = isMobile;
}
